import { makeStyles } from '@material-ui/styles';

const menuWidth = 240;

export default makeStyles((theme: any) => ({
  content: {
    width: menuWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  menu: {
    height: '100vh',
    position: 'fixed',
  },
  menuOpen: {
    width: menuWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      visibility: 'visible',
      position: 'fixed',
      'z-index': 1000,
    },
  },
  menuClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 24,
    [theme.breakpoints.down('sm')]: {
      visibility: 'hidden',
      position: 'fixed',
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  linkIcon: {
    fontSize: '24px !important',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  linkSpan: {
    width: '100%',
  },
}));
